import React from "react";
import { Route, Switch } from "react-router-dom";
import Add from "./Add";
import List from "./List";
import Summary from "./Summary";
import Edit from "./Edit";
import { MaterialSuppliers } from "./suppliers/Index";
import MaterialTypeTransactions from "./Transactions";

import AquaAdd from "./aqua/Add";
import AquaList from "./aqua/List";
import AquaSummary from "./aqua/Summary";
import AquaTransactions from "./aqua/Transactions";

import { Auth } from "_helpers";

function MaterialTypes({ match }) {
  const { path } = match;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "AQUA") {
    return (
      <Switch>
        <Route exact path={path} component={AquaList} />
        <Route path={`${path}/add`} component={AquaAdd} />
        <Route path={`${path}/:id/summary`} component={AquaSummary} />
        <Route path={`${path}/:id/suppliers`} component={MaterialSuppliers} />
        <Route path={`${path}/:id/transactions`} component={AquaTransactions}/>
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/add`} component={Add} />
        <Route path={`${path}/:id/summary`} component={Summary} />
        <Route path={`${path}/:id/edit`} component={Edit} />
        <Route path={`${path}/:id/suppliers`} component={MaterialSuppliers} />
        <Route path={`${path}/:id/transactions`} component={MaterialTypeTransactions}/>
      </Switch>
    );
  }
}

export { MaterialTypes };
